import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import * as _ from 'lodash';

import { CuttingClientOptions, PanelTableField } from '../../../models/cutting/cutting-client.model';
import { CuttingPanelListService } from '../cutting-panel-list.service';

@Component({
  selector: 'csl-field-settings',
  templateUrl: './field-settings.component.html',
  styleUrls: ['./field-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FieldSettingsComponent implements OnInit {
  displayedColumns = ['visible', 'name'];
  dataSource = new MatTableDataSource<PanelTableField>([]);
  systemColumns: string[] = ['l1', 'l2', 'w1', 'w2', 'delete', 'width', 'height', 'count'];
  selection: SelectionModel<string> = new SelectionModel<string>(true, []);

  constructor(
    private cuttingPanelListService: CuttingPanelListService, //
    public dialogRef: MatDialogRef<FieldSettingsComponent>
  ) {}

  ngOnInit(): void {
    this.cuttingPanelListService.onClientOptionsChanged.subscribe((response: CuttingClientOptions) => {
      this.dataSource.data = this.deleteSystemColumns(_.cloneDeep(response.panelTableFields));
      this.selection.select(...this.dataSource.data.filter(f => f.visible).map(f => f.name));
    });
  }

  private deleteSystemColumns(fields: any[]): any[] {
    return fields.filter(col => this.systemColumns.indexOf(col.name) === -1);
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.selection.select(row.name));
  }

  saveOptionsAndClose(): void {
    this.saveDataSourceToOptions(this.dataSource.data);

    this.cuttingPanelListService
      .saveClientOptions(this.cuttingPanelListService.onClientOptionsChanged.value)
      .then(() => {
        this.dialogRef.close(this.cuttingPanelListService.onClientOptionsChanged.value);
      });
  }

  saveDataSourceToOptions(dsData: PanelTableField[]): void {
    dsData.forEach(item => {
      this.cuttingPanelListService.onClientOptionsChanged.value.panelTableFields.forEach(itemOptions => {
        if (item.name === itemOptions.name) {
          itemOptions.displayName = item.displayName;
          itemOptions.visible = this.selection.isSelected(item.name);
          itemOptions.description = item.description;
        }
      });
    });
  }
}
